module.exports = __webpack_public_path__ + "img/gauge.b8f129b6.svg";